import {
  faBook,
  faCalendarAlt,
  faCheckCircle,
  faEdit,
  faExclamation,
  faExclamationCircle,
  faInfoCircle,
  faLocationArrow,
  faMapMarkedAlt,
  faSave,
  faStop,
  faStopCircle,
  faTrashAlt,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import IconAlert from 'components/common/IconAlert';
import draftEntryUiHelper from 'helpers/draft-entry-ui-helper';
import segmentHelper from 'helpers/segment-helper';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  InputGroup,
  ListGroup,
  Offcanvas,
  OverlayTrigger,
  Popover,
  Row,
  Spinner,
  Tooltip
} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { refreshSavedLocation } from 'stores/app';
import { showAlert, showConfirm } from 'stores/modal';
import apiHelper from 'util/apiHelper';
import {
  actionLogSigningAction,
  actionSetLocalTimezone,
  actionSetLocationInfo,
  actionSetType,
  actionSetSigningTimestamp,
  actionSetUserProfileGUID
} from 'stores/signing';
import Colors from 'util/Colors';
import api from 'util/api';
import c from 'util/const';
import enums from 'util/enums';
import geolocationService from 'util/geolocation-svc';
import logger from 'util/logger';
import AddressForm from './comp/AddressForm';
import 'react-datepicker/dist/react-datepicker.css';
import userHelper from 'helpers/userHelper';
import { object } from 'is_js';
import _ from 'lodash';

const Step1 = ({ register, errors, setPreviousAddress }) => {
  const dispatch = useDispatch();
  const {
    location,
    Type,
    signing_timestamp,
    localTimezone,
    userProfileGUID,
    auditLog
  } = useSelector(state => state.signing);
  const { savedLocations, userProfile, userMaster } = useSelector(
    state => state.app
  );
  const [favoriteLocationsDisplay, setFavoriteLocationsDisplay] = useState([]);
  const [sortBy, setSortBy] = useState('Created');
  const [isAsc, setIsAsc] = useState(false);
  const [stateDiffNotice, setStateDiffNotice] = useState(false);

  const [showLocationCanvas, setShowLocationCanvas] = useState(false);
  const [isLoadingLocations, setIsLoadingLocations] = useState(false);
  const [startSavingFavourite, setStartSavingFavourite] = useState(0);
  const [signingTimestamp, setSigningTimestamp] = useState(null);
  const [localTimezoneVal, setLocalTimezoneVal] = useState(null);
  const [userProfileGUIDVal, setUserProfileGUIDVal] = useState(null);
  const [isDatePickerOpen, setDatePickerOpen] = useState(null);
  const [prevSigningTimestamp, setPrevSigningTimestamp] = useState(null);

  const [signingLocation, setSigningLoction] = useState({
    validationErr: [],
    address_1: location?.address_1 || '',
    address_2: location?.address_2 || '',
    city: location?.city || '',
    state: location?.state || '',
    zip: location?.zip || '',
    latitude: location?.latitude,
    longitude: location?.longitude,
    isDetectingLocation: false,
    isSavingLocation: false,
    initialAddressString: '',
    showingLocationNamePrompt: false,
    locationName: location ? location.locationName || null : null
  });

  const states = c.states;

  const isProfileActive = profile => {
    return (
      profile?.Active &&
      moment()
        .startOf('day')
        .isSameOrBefore(moment(profile?.ExpirationDate).utc())
    );
  };

  const getDisplayProfiles = () => {
    const profiles = userProfile || [];
    const defaults = profiles.filter(p => p?.IsDefault);
    const actives = profiles.filter(p => !p?.IsDefault && isProfileActive(p));
    return [...defaults, ...actives] || [];
  };

  const clearNotarizationDate = () => {
    setSigningTimestamp(null);
    dispatch(actionLogSigningAction(`Notarization date & time removed.`));
  };

  const setSigningData = (field, value) => {
    setSigningLoction(signingLocation => ({
      ...signingLocation,
      [field]: value
    }));
  };

  const setSearchedAddress = address => {
    logger.log('Updating serach address', address);

    // setSigningLoction(signingLocation => ({
    //   ...signingLocation,
    //   address
    // }));

    setSigningLoction(signingLocation => ({
      ...signingLocation,
      address_1: address.address_1 || '',
      address_2: address.address_2 || '',
      city: address.city || '',
      state: address.state || '',
      zip: address.zip || ''
    }));
  };

  const setPreviousSigningTimestamp = () => {
    logger.log('SigningTimestamp Previos Date called. modal open');
    setDatePickerOpen(true);
    setPrevSigningTimestamp(signingTimestamp);
  };

  const logSigningSigningTimestamp = () => {
    setDatePickerOpen(false);
  };

  const hasSavableAddress = () => {
    let addr = _.trim(draftEntryUiHelper.getDisplayAddress(signingLocation));
    return addr && addr.length > 0;
  };

  const saveLocationClick = () => {
    dispatch(
      showConfirm(
        'Save location to favorite',
        <div>
          <p>Location name</p>
          <Form.Group className="mb-3">
            <Form.Control
              placeholder="Enter location name"
              value={location.locationName}
              name="locationName"
              // onChange={(evt) => { dispatch(actionSetLocationName(evt.target.value)); }}
              onChange={evt => {
                setSigningData('locationName', evt.target.value);
              }}
              type="text"
            />
          </Form.Group>
        </div>,
        res => {
          if (res) {
            setStartSavingFavourite(startSavingFavourite + 1);
          }
        }
      )
    );
  };

  const proceedToSaveLocation = () => {
    let { locationName, address_1, address_2, city, state, zip } =
      signingLocation;
    if (!locationName || locationName.length == 0) {
      toast.warning('Location name is required', {
        theme: 'colored',
        position: 'bottom-center',
        icon: faExclamation
      });
      return;
    }

    setSigningLoction(signingLocation => ({
      ...signingLocation,
      isSavingLocation: true
    }));
    //this.props.state.app.segmentClient.track('Favorite Location Saved');
    api.SavedLocations.add(locationName, address_1, address_2, city, state, zip)
      .then(res => {
        setSigningLoction(signingLocation => ({
          ...signingLocation,
          isSavingLocation: false
        }));
        //logger.log('saved location created', res);
        return dispatch(refreshSavedLocation());
      })
      .then(() => {
        segmentHelper.track(
          segmentHelper.events.SIGNING_FAVORITE_LOCATION_SAVED
        );
        toast.success('Favorite Location Saved', {
          theme: 'colored',
          position: 'bottom-center',
          icon: faCheckCircle,
          toastId: 'signing'
        });
      })
      .catch(err => {
        setSigningLoction(signingLocation => ({
          ...signingLocation,
          isSavingLocation: false
        }));
        if (apiHelper.isConnectionError(err)) {
          dispatch(
            showAlert(
              'Connection error',
              'Oops.. we are unable to connect server. Check internet connection'
            )
          );
        } else {
          dispatch(
            showAlert(
              'Unable to Save Location',
              'There was a problem saving your Location.  Please try again.'
            )
          );
        }
      });
  };

  const detectLocation = () => {
    logger.log('detectLocation was clicked');
    segmentHelper.track(
      segmentHelper.events.SIGNING_DETECT_TO_CURRENT_LOCATION_CLICK
    );
    setSigningLoction(signingLocation => ({
      ...signingLocation,
      isDetectingLocation: true
    }));
    let coords = {};
    //this.props.state.app.segmentClient.track('Detect current location clicked');
    try {
      geolocationService
        .detectCoords()
        .then(res => {
          logger.log('geolocationService res', res);

          //logger.log('geolocationService detectCoords res', res);
          if (res.latitude) {
            coords.latitude = res.latitude;
          }
          if (res.longitude) {
            coords.longitude = res.longitude;
          }
          return api.Location.lookup(res.latitude, res.longitude);
        })
        .then(res => {
          logger.log('geolocationService location lookup res', res);

          setSigningLoction(signingLocation => ({
            ...signingLocation,
            isDetectingLocation: false
          }));
          logger.log('Address lookup', res);
          populateStateFromAddress(res);
        })
        .catch(err => {
          setSigningLoction(signingLocation => ({
            ...signingLocation,
            isDetectingLocation: false
          }));
          if (err.message === 'timed out') {
            toast.warning(
              'Location detection is taking too long. Please check permissions or try again.',
              {
                theme: 'colored',
                position: 'bottom-center',
                icon: faExclamationCircle,
                toastId: 'timeout-warning'
              }
            );
          } else {
            toast.error('Unable to detect your current location', {
              theme: 'colored',
              position: 'bottom-center',
              icon: faExclamationCircle,
              toastId: 'location-error'
            });
          }

          logger.log('error detecting coords', err);
        })
        .finally(err => {
          logger.log('finally detecting coords', err);
          setSigningLoction(signingLocation => ({
            ...signingLocation,
            isDetectingLocation: false
          }));
        });
    } catch (err) {
      setSigningLoction(signingLocation => ({
        ...signingLocation,
        isDetectingLocation: false
      }));
      toast.warning('Google Geo Location service is not available', {
        theme: 'colored',
        position: 'bottom-center',
        icon: faExclamationCircle,
        toastId: 'signing'
      });
      logger.log('Geolocation is not working with this domain', err);
    }
  };

  const populateStateFromAddress = res => {
    setSigningLoction(signingLocation => ({
      ...signingLocation,
      address_1:
        (res.StreetNumber ? res.StreetNumber : '') +
        (res.StreetName ? ' ' + res.StreetName : ''),
      city: res.City,
      state: res.StateAbbreviated,
      zip: res.Postal,
      longitude: res.Latitude,
      latitude: res.Latitude
    }));
  };

  const applySavedLocation = loc => {
    setSigningLoction(signingLocation => ({
      ...signingLocation,
      address_1: loc.Address1 || '',
      address_2: loc.Address2 || '',
      city: loc.City || '',
      state: loc.State || '',
      zip: loc.PostalCode || ''
    }));
  };

  const searchItems = e => {
    const keyword = e.target.value.toLowerCase().trim();
    if (!keyword) {
      setFavoriteLocationsDisplay(savedLocations || []);
      return;
    }
    // Full-text search across all location fields rather than a few specific ones.
    const filterFavoriteLocations = _.filter(savedLocations || [], d => {
      const haystack = [
        d.DisplayName,
        d.Address1,
        d.Address2,
        d.City,
        d.State,
        d.Province,
        d.Country,
        d.PostalCode,
        d.Telephone,
        d.locationName,
        moment.utc(d.Created).local().format('l, LT')
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return haystack.includes(keyword);
    });
    setFavoriteLocationsDisplay(filterFavoriteLocations);
  };

  useEffect(() => {
    const sortedFavoriteLocations = _.orderBy(
      savedLocations || [],
      [sortBy],
      [isAsc ? 'asc' : 'desc']
    );
    setFavoriteLocationsDisplay(sortedFavoriteLocations);
  }, [savedLocations, sortBy, isAsc]);

  const didInitRef = React.useRef(false);
  useEffect(() => {
    // Drafts may not have signing_timestamp yet, so don't use it to decide draft vs new.
    // Prefer restored redux values (userProfileGUID/localTimezone), otherwise fall back to defaults.
    if (didInitRef.current) return;
    if (!userMaster) return;

    didInitRef.current = true;

    setPreviousAddress(location);
    // signing_timestamp is pre-populated with the current time when a new entry starts
    // (see the signing "start" reducer), so new entries show it immediately and drafts
    // keep their saved value.
    setSigningTimestamp(signing_timestamp ? new Date(signing_timestamp) : null);

    const defaultProfileGuid =
      userProfile?.find(p => p.IsDefault)?.GUID || _.first(userProfile)?.GUID;
    const initialProfileGuid = userProfileGUID || defaultProfileGuid || '';
    setUserProfileGUIDVal(initialProfileGuid);

    const profileTimezone = initialProfileGuid
      ? _.find(userProfile, p => p.GUID === initialProfileGuid)?.LocalTimezone
      : null;
    const initialTimezone =
      localTimezone || profileTimezone || userMaster?.LocalTimezone || '';
    changeLocalTimezone(userHelper.getTimezoneVal(initialTimezone));
  }, [
    userMaster,
    userProfile,
    userProfileGUID,
    localTimezone,
    signing_timestamp,
    location,
    setPreviousAddress
  ]);

  useEffect(() => {
    if (
      location?.state &&
      userProfileGUID &&
      location?.state !==
        _.find(userProfile, p => p.GUID === userProfileGUID)?.CommissionState
    ) {
      setStateDiffNotice(true);
    } else {
      setStateDiffNotice(false);
    }
  }, [location?.state, userProfileGUID]);

  useEffect(() => {
    // If draft restore updates redux after mount, keep local controlled value in sync.
    if (userProfileGUID) {
      setUserProfileGUIDVal(userProfileGUID);
    }
  }, [userProfileGUID]);

  useEffect(() => {
    if (signing_timestamp) {
      setSigningTimestamp(new Date(signing_timestamp));
    }
  }, [signing_timestamp]);

  useEffect(() => {
    // DatePicker state can show a default time before redux is reinstate-synced.
    if (signingTimestamp && !signing_timestamp) {
      dispatch(actionSetSigningTimestamp(moment(signingTimestamp).format()));
    }
  }, [signingTimestamp, signing_timestamp, dispatch]);

  useEffect(() => {
    // Keep timezone in sync with selected commission profile, but prefer explicit draft timezone.
    if (localTimezone) {
      setLocalTimezoneVal(userHelper.getTimezoneVal(localTimezone));
      return;
    }
    if (!userProfileGUID) return;
    const tz = _.find(
      userProfile,
      p => p.GUID === userProfileGUID
    )?.LocalTimezone;
    if (!tz) return;
    setLocalTimezoneVal(userHelper.getTimezoneVal(tz));
  }, [userProfileGUID, userProfile, localTimezone]);

  // useEffect(() => {
  //   if (signingLocation.longitude)
  //     dispatch(
  //       actionLogSigningAction(
  //         `Location detected as ${draftEntryUiHelper.getDisplayAddress(
  //           signingLocation
  //         )}`
  //       )
  //     );
  // }, [signingLocation.longitude]);

  useEffect(() => {
    //logger.log('Updating location stage', signingLocation);
    dispatch(actionSetLocationInfo(signingLocation));
  }, [signingLocation]);

  const typeSetToLoggedRef = React.useRef(false);
  useEffect(() => {
    if (Type) {
      const typeAuditLog = 'Notarization type set to';
      const hasTypeInAuditLog = auditLog.some(log =>
        log.description.includes(typeAuditLog)
      );
      if (!hasTypeInAuditLog && !typeSetToLoggedRef.current) {
        typeSetToLoggedRef.current = true;
        const label =
          enums.SIGNING_TYPE_OPTIONS.find(o => o.value === Type)?.label || Type;
        dispatch(actionSetType(Type));
        dispatch(actionLogSigningAction(`Notarization type set to ${label}.`));
      }
    }
  }, [Type]);

  useEffect(() => {
    if (startSavingFavourite) {
      proceedToSaveLocation();
    }
  }, [startSavingFavourite]);

  useEffect(() => {
    if (
      !isDatePickerOpen &&
      signingTimestamp &&
      prevSigningTimestamp !== signingTimestamp
    ) {
      dispatch(
        actionSetSigningTimestamp(moment(signingTimestamp).format())
      ).then(() => {
        dispatch(
          actionLogSigningAction(
            `Notarization date & time added ${draftEntryUiHelper
              .getDateTimeWithTimeZone(moment(signingTimestamp).local())

              .format(c.dateFormat)}.`
          )
        );
      });
    }
  }, [isDatePickerOpen]);

  useEffect(() => {
    if (userProfileGUIDVal) {
      let commProfile = _.find(userProfile, p => p.GUID == userProfileGUIDVal);
      let commissionAuditLog = 'Commission profile set to';
      const hasCommisionChange = auditLog.some(log =>
        log.description.includes(commissionAuditLog)
      );
      if (!hasCommisionChange) {
        dispatch(actionSetUserProfileGUID(userProfileGUIDVal)).then(() => {
          dispatch(
            actionLogSigningAction(
              `Commission profile set to ${commProfile?.CommissionedName} (${commProfile?.CommissionNumber}).`
            )
          );
        });
      }
    }
  }, [userProfileGUIDVal]);

  const signingTimestampPopver = (
    <Popover id="notarization-date-time">
      <Popover.Header as="h3">Notarization Date & Time</Popover.Header>
      <Popover.Body>
        Detect your current Location, or Load a Favorite. You can also search
        for one or enter it manually below. If you save what you've entered as a
        Favorite, you can access it again from any device.
      </Popover.Body>
    </Popover>
  );

  const loadAvailableLocation = () => {
    setShowLocationCanvas(true);
    setIsLoadingLocations(true);
    // Ensure the drawer shows the user's current favorites even if they weren't
    // loaded during entry initialization (savedLocations can be empty when
    // arriving via certain paths, e.g. resuming a draft).
    Promise.resolve(dispatch(refreshSavedLocation()))
      .catch(err => {
        logger.log('error loading saved locations', err);
        if (!apiHelper.isConnectionError(err)) {
          dispatch(
            showAlert(
              'Unable to Load Saved Locations',
              'There was a problem loading your saved locations. Please try again.'
            )
          );
        }
      })
      .finally(() => {
        setIsLoadingLocations(false);
      });
  };

  const selectSavedLocation = loc => {
    let selectedLcation = _.filter(savedLocations, l => {
      return l.GUID === loc;
    });
    //logger.log(selectedLcation);
    applySavedLocation(selectedLcation[0]);
    setShowLocationCanvas(false);
  };

  const removeItemClick = guid => {
    dispatch(
      showConfirm(
        'Are you sure?',
        <div>
          <p>Are you sure you want to delete this location?</p>
        </div>,
        res => {
          if (res) {
            api.SavedLocations.remove(guid)
              .then(res => {
                toast.success('Location deleted successfully', {
                  theme: 'colored',
                  position: 'bottom-center',
                  icon: faCheckCircle
                });
                return dispatch(refreshSavedLocation());
              })
              .catch(err => {
                //logger.log('error removing saved location', err);
                if (apiHelper.isConnectionError(err)) {
                } else {
                  dispatch(
                    showAlert(
                      'Unable to Remove Saved Location',
                      'There was a problem removing your saved location.  Please try again.'
                    )
                  );
                }
              });
          }
        }
      )
    );
  };

  const changeLocalTimezone = value => {
    setLocalTimezoneVal(value);
    const localTimezoneAuditLog = 'Local timezone set to';
    const hasLocalTimezoneChange = auditLog.some(log =>
      log.description.includes(localTimezoneAuditLog)
    );
    if (!hasLocalTimezoneChange) {
      dispatch(actionSetLocalTimezone(value)).then(() => {
        dispatch(
          actionLogSigningAction(
            `Local timezone set to ${userHelper.getTimezoneObj(value)?.zone}.`
          )
        );
      });
    } else {
      dispatch(actionSetLocalTimezone(value)).then(() => {
        dispatch(
          actionLogSigningAction(
            `Local timezone changed to ${
              userHelper.getTimezoneObj(value)?.zone
            }.`
          )
        );
      });
    }
  };

  const changeUserProfileGUID = value => {
    if (value.length === 0) {
      return;
    }
    setUserProfileGUIDVal(value);
    let commProfile = _.find(userProfile, p => p.GUID == value);
    let commissionAuditLog = 'Commission profile set to';
    const hasCommisionChange = auditLog.some(log =>
      log.description.includes(commissionAuditLog)
    );
    if (!hasCommisionChange) {
      dispatch(actionSetUserProfileGUID(value)).then(() => {
        dispatch(
          actionLogSigningAction(
            `Commission profile set to ${commProfile?.CommissionedName} (${commProfile?.CommissionNumber}).`
          )
        );
      });
    } else {
      dispatch(actionSetUserProfileGUID(value)).then(() => {
        dispatch(
          actionLogSigningAction(
            `Commission profile changed to ${commProfile?.CommissionedName} (${commProfile?.CommissionNumber}).`
          )
        );
      });
    }
  };

  const changeType = value => {
    const label =
      enums.SIGNING_TYPE_OPTIONS.find(o => o.value === value)?.label || value;
    dispatch(actionSetType(value));
    dispatch(actionLogSigningAction(`Notarization type changed to ${label}.`));
  };

  const LocationViewCanvas = ({ savedLocations, ...props }) => {
    //logger.log("savedLocations", savedLocations);
    return <></>;
  };

  return (
    <>
      {/* <h5 className="text-center">Notarization Date & Time & Address</h5> */}
      <Row>
        <Col sm={12}>
          <IconAlert variant="info">
            <p className="mb-0">
              Detect your current Location, or Load a Favorite. You can also
              search for one or enter it manually below. If you save what you've
              entered as a Favorite, you can access it again from any device.
            </p>
          </IconAlert>
        </Col>
      </Row>
      <hr className="my-0" />
      <Row className="g-2 my-3">
        <Col sm={4}>
          <Flex
            justifyContent="center"
            className="bg-soft-primary py-3 rounded border"
          >
            <Button
              variant="primary"
              disabled={signingLocation.isDetectingLocation}
              onClick={() => detectLocation()}
            >
              {signingLocation.isDetectingLocation ? (
                <Spinner size="sm" />
              ) : (
                <FontAwesomeIcon icon={faMapMarkedAlt} />
              )}{' '}
              {signingLocation.isDetectingLocation
                ? 'Detecting'
                : 'Detect current location'}
            </Button>
            {signingLocation.isDetectingLocation && (
              <Button
                className="ms-2"
                onClick={() => {
                  setSigningLoction(signingLocation => ({
                    ...signingLocation,
                    isDetectingLocation: false
                  }));
                }}
                variant="outline-danger"
              >
                <FontAwesomeIcon icon={faStop} />
              </Button>
            )}
          </Flex>
        </Col>
        <Col sm={4}>
          <Flex
            justifyContent="center"
            className="bg-soft-primary py-3 rounded border"
          >
            <Button
              variant="primary"
              type="button"
              onClick={() => loadAvailableLocation()}
            >
              <FontAwesomeIcon icon={faBook} /> Load saved location
            </Button>
          </Flex>
        </Col>
        <Col sm={4}>
          <Flex
            justifyContent="center"
            className="bg-soft-primary py-3 rounded border"
          >
            <Button
              variant="primary"
              disabled={
                signingLocation.isDetectingLocation ||
                signingLocation.isSavingLocation ||
                !hasSavableAddress()
              }
              onClick={() => saveLocationClick()}
            >
              {' '}
              {signingLocation.isSavingLocation ? (
                <Spinner size="sm" />
              ) : (
                <FontAwesomeIcon icon={faSave} />
              )}{' '}
              {signingLocation.isSavingLocation
                ? 'Saving'
                : 'Save current location'}
            </Button>
          </Flex>
        </Col>
      </Row>

      <Row className="g-2 mb-3">
        <Col sm={4}>
          <Flex alignItems="end">
            <Form.Group>
              <Form.Label>Notarization Date & Time*</Form.Label>

              <DatePicker
                showTimeSelect
                selected={signingTimestamp ? signingTimestamp : null}
                onChange={date => setSigningTimestamp(date)}
                dateFormat="MM/dd/yyyy hh:mm a"
                className="form-control"
                placeholderText="Select Date & Time"
                timeIntervals={5}
                onCalendarClose={logSigningSigningTimestamp}
                onCalendarOpen={setPreviousSigningTimestamp}
              />
            </Form.Group>

            <Button variant="outline-primary" className="mx-1">
              <FontAwesomeIcon
                icon={faTrashAlt}
                onClick={() => clearNotarizationDate()}
              />
            </Button>
            {/* <OverlayTrigger
              trigger="click"
              placement="top"
              overlay={SigningTimestampPopver}
              delay={500}
            >
              <Button variant="outline-info">
                <FontAwesomeIcon icon={faInfoCircle} />
              </Button>
            </OverlayTrigger> */}
          </Flex>
        </Col>

        <Col sm={4}>
          <Form.Group as={Col} lg={12} controlId="LocalTimezone">
            <Form.Label>
              Commission profile*{' '}
              {userProfileGUID && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      {stateDiffNotice
                        ? "The state entered in the location field does not match the selected commission profile's state. You can still proceed with this entry, but please check to make sure you have the correct commission profile selected"
                        : "The selected commission profile's state matches the location selected below"}
                    </Tooltip>
                  }
                >
                  <span>
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      className={
                        stateDiffNotice ? 'text-warning' : 'text-success'
                      }
                    />
                  </span>
                </OverlayTrigger>
              )}
            </Form.Label>
            <Form.Select
              type="text"
              name="LocalTimezone"
              onChange={e => changeUserProfileGUID(e.target.value)}
              value={userProfileGUIDVal || ''}
            >
              <option value="">Select commission profile</option>
              {getDisplayProfiles().length === 0 ? (
                <>
                  <option value="" disabled>
                    No active Commission Profiles available.
                  </option>
                  <option value="" disabled>
                    Please add new profile from Notary Profile Commission.
                  </option>
                </>
              ) : (
                getDisplayProfiles().map(option => (
                  <option value={option.GUID} key={option.GUID}>
                    {option.CommissionedName} {option.CommissionNumber} /{' '}
                    {userHelper.getTimezoneObj(option.LocalTimezone)?.name}
                  </option>
                ))
              )}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col sm={4}>
          <Form.Group as={Col} lg={12} controlId="LocalTimezone">
            <Form.Label>Timezone</Form.Label>
            <Form.Select
              type="text"
              name="LocalTimezone"
              onChange={e => changeLocalTimezone(e.target.value)}
              value={localTimezoneVal || ''}
            >
              <option value="">Select timezone</option>
              {c.timezones.map(option => (
                <option value={option.zone} key={option.zone}>
                  {option.name} ({option.zone})
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      {stateDiffNotice && (
        <Row>
          <Col sm={12}>
            <IconAlert variant="warning">
              <p className="mb-0">
                The state entered in the location field does not match the
                selected commission profile's state. You can still proceed with
                this entry, but please check to make sure you have the correct
                commission profile selected
              </p>
            </IconAlert>
          </Col>
        </Row>
      )}

      <Row className="g-2 mb-3">
        <Col sm={12} md={4}>
          <Form.Group controlId="SigningType">
            <Form.Label>Notarization type*</Form.Label>
            <Form.Select
              value={Type}
              onChange={e => changeType(e.target.value)}
              name="Type"
            >
              {enums.SIGNING_TYPE_OPTIONS.map(opt => (
                <option value={opt.value} key={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <AddressForm
        address={signingLocation}
        setAddressValue={setSigningData}
        setSearchedAddress={setSearchedAddress}
        register={register}
        errors={errors}
      />

      <div className="py-0 my-0 fs--2 text-primary w-100">
        <b>Note:</b> All * input fields are required.
      </div>
      <Offcanvas
        show={showLocationCanvas}
        backdrop="static"
        enforceFocus={false}
        onHide={() => setShowLocationCanvas(false)}
        placement="end"
        className="jurat-wide-offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Saved Favorite Location</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Flex className={'g-2'}>
            <div className="mb-2">
              <Form as={Row} className="gx-2 d-flex align-items-center">
                <Col xs="auto">
                  <InputGroup>
                    <Form.Select
                      className="pe-5"
                      defaultValue="Created"
                      onChange={({ target }) => setSortBy(target.value)}
                    >
                      <option value="DisplayName">Name</option>
                      <option value="Created">Created</option>
                    </Form.Select>
                    <InputGroup.Text
                      as={Button}
                      variant="link"
                      className="border border-300 text-700"
                      onClick={() => setIsAsc(!isAsc)}
                    >
                      <FontAwesomeIcon
                        icon={isAsc ? 'sort-amount-up' : 'sort-amount-down'}
                      />
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
              </Form>
            </div>
            <div className="mx-1">
              <Form.Control
                onChange={e => searchItems(e)}
                placeholder="search location..."
                name="search"
              ></Form.Control>
            </div>
          </Flex>
          {isLoadingLocations ? (
            <Flex
              className="py-5"
              alignItems="center"
              justifyContent="center"
              direction="column"
            >
              <Spinner animation="border" variant="primary" />
              <p className="mt-3 mb-0 text-muted">Loading saved locations...</p>
            </Flex>
          ) : favoriteLocationsDisplay?.length > 0 ? (
            <ListGroup>
              {favoriteLocationsDisplay.map((item, index) => (
                <ListGroup.Item
                  className="cursor-pointer"
                  key={item.GUID}
                  onClick={() => selectSavedLocation(item.GUID)}
                >
                  <Flex justifyContent="between" alignItems="center">
                    <h6>{item.DisplayName}</h6>
                    <div>
                      <FontAwesomeIcon
                        color={Colors.danger.color}
                        className="ms-1"
                        size="sm"
                        icon={faTrashAlt}
                        onClick={() => removeItemClick(item.GUID)}
                      />
                    </div>
                  </Flex>
                  <p className="mb-1">
                    {item.Address1 ? item.Address1 + ', ' : ''}{' '}
                    {item.City ? item.City + ', ' : ''} {item.State} -{' '}
                    {item.PostalCode}
                  </p>
                  <p className="my-0 fs--2 text-muted">
                    <FontAwesomeIcon icon={faCalendarAlt} />{' '}
                    {moment(item.Created).utc().format('MM/DD/YYYY HH:mm A')}
                  </p>
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <div className="text-center">
              <FontAwesomeIcon icon={faLocationArrow} size="3x" />
              <br />
              <p className="my-3">
                You don't have any favorite location yet. <br />
                Use "Save current location" after entering an address, or add
                favorites from the Library. We recommend adding your office or
                any regular place of business where you normally meet with
                clients.
              </p>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

Step1.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object
};

export default Step1;
